var NewUserRewardPanel = require("clover/panel/NewUserRewardPanel")
var ButtonPushBounceAnim = require("clover/panel/component/common/uiButtonAnims/PushBounceAnim")
var QzoneBackgoundRewardsPanel = xClass("QzoneBackgoundRewardsPanel", NewUserRewardPanel, function () {
    return cc.CSLoader.createNode("cocos/qzone_cover_panel2.csb")
})

var resList = [
    "cocos/qzone_cover_panel1_btn.csb",
    "cocos/qzone_cover_panel1.csb",
    "cocos/qzone_cover_panel2_btn.csb",
    "cocos/qzone_cover_panel2.csb",
    "cocos/qzone_cover_racoon_light.csb",
    "cocos/qzone_cover.plist"
]
QzoneBackgoundRewardsPanel.asyncCreate = function (onCloseCallback, fail, cancel) {
    function onSuccess() {
        let panel = QzoneBackgoundRewardsPanel.create(onCloseCallback)
        panel.popup()
    }
    preloadWithLoading(resList, onSuccess, fail, cancel)
}
QzoneBackgoundRewardsPanel.prototype.itemPos = table([1, 2, table(
    [1, 1, table([0, 127 + 70], [0, -257])],
    [1, 2, table([0, 271 + 165], [0, -257])],
)])
QzoneBackgoundRewardsPanel.prototype.ctor = function (onCloseCallback) {
    var self = this
    // self.config = clone(info)
    // self.newConfig = clone(newInfo)
    // self.rewards = rewards
    NewUserRewardPanel.prototype.ctor.call(self, onCloseCallback)
    return;
    self.buildUI(info)
    var scaleY = display.height / GamePlayConfig_Design_Height
    var scaleX = display.width / GamePlayConfig_Design_Width
    var scale = Math.min(scaleX, scaleY)
    self._scale = scale
    self.setScale(scale)
}

QzoneBackgoundRewardsPanel.prototype.init = function () {
    var self = this
    BasePanel.prototype.init.call(self)
    self.setScale(self.getReferenceScale())
    var newReward =  MetaManager.getInstance().getSetQzoneBackgroundRewards()
    self.config = newReward
    // self.createInfiniteEnergy(newReward[1])
    // self.getChildByName("desc").setVisible(false)
    // self.getChildByName("energybg").setVisible(false)
    // let size = self.getChildByName("energybg").getContentSize()
    let all_size = self.getContentSize()
    // self.getChildByName("desc").removeFromParent(true)
    // self.getChildByName("energybg").removeFromParent(true)
    // self.setContentSize(all_size.width, all_size.height - size.height)
    // self.getChildByName("bg").removeFromParent(true)

    // var titleLabel = cc.Label.createWithSystemFont("空间专属背景设置成功", "Arial", 40, 400)
    // titleLabel.setTextColor(cc.color(180, 119, 59, 255))
    // titleLabel._setFontWeight("bold")
    // titleLabel.setAnchorPoint(cc.p(0.5, 0.5))
    // titleLabel.setPosition(275, -133)
    // self.addChild(titleLabel)
    var title = self.getChildByName("title")
    title.setString(getText("qzone.background.rewards.panel.title"))
    title.setPositionY(title.getPositionY() - 10)
    title.setPositionX(title.getPositionX() - 5)

    var rewardCount = $len(newReward)
    var $limit27 = rewardCount
    for (var i = 1; i <= $limit27; i += 1) {
        var config = newReward[i]
        self.createRewardItem(i, config, rewardCount)
    }

    var light1 = self.getChildByName("racoon_light1")
    var timeline1 = cc.CSLoader.createTimeline("cocos/qzone_cover_racoon_light.csb")
    light1.runAction(timeline1)
    timeline1.gotoFrameAndPlay(0, true)

    var light2 = self.getChildByName("racoon_light2")
    var timeline2 = cc.CSLoader.createTimeline("cocos/qzone_cover_racoon_light.csb")
    light2.runAction(timeline2)
    timeline2.gotoFrameAndPlay(0, true)

    var btn = self.getChildByName("btn")
    // var label = btn.getChildByName("label")
    // label.setAnchorPoint(cc.p(0.5, 0.5))
    // label.setPosition(52, -5)
    // // read from strings
    // label.setString("领取奖励")
    self.getbtn = UIGroupButton.create(btn)
    self.getbtn.setText(getText("qzone.background.rewards.panel.btn"))
    var label = self.getbtn.getChildByName("label")
    label.setPositionY(label.getPositionY() - 8)
    PushBounceIdleBubbleAnim.create(self.getbtn)
    self.busy = false
    self.getbtn.on(UIButtonEvent.Click, function () {
        self.getReward()
    })
}

QzoneBackgoundRewardsPanel.prototype.createRewardItem = function (index, config, rewardCount) {
    var self = this
    var itemId = config.itemId
    var num = config.num
    var [posX, posY] = [self.itemPos[rewardCount][index][1], self.itemPos[rewardCount][index][2]]
    var icon = UIItemBuilder.createProp(itemId, num, 0, true)[0]
    icon.setPosition(posX, posY)
    self.addChild(icon, 5)
    self.rewardItems[index] = icon
}

QzoneBackgoundRewardsPanel.prototype.getReward = function () {
    var self = this
    self.getbtn.setEnabled(false)
    UserNewReward.getInstance().getSetQzoneBackgroundRewards(function () {
        self.playItemAnimation(function () {
            self.onClose()
            self.busy = false
        })
    }, function (error) {
        alert('领取失败')
        self.onClose()
        self.busy = false
    })
}

module.exports = QzoneBackgoundRewardsPanel